module.exports = __webpack_public_path__ + "assets/f40c70d15b3f67cb823a75ce6a3c4a34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-news.jpg
// module id = 796
// module chunks = 0